<section class="our-software">
  <div class="box-container">
    <!-- topic -->
    <div class="software-topic">
      <!-- desktop heading -->
      <div
        class="software-topic__heading software-topic__heading--desktop color-gray"
        [innerHTML]="'WORK_WITH_US.OUR_SOFTWARE.HEADING_MOBILE' | translate"
      ></div>

      <!-- tablet heading -->
      <div
        class="software-topic__heading software-topic__heading--tablet color-gray"
        [innerHTML]="'WORK_WITH_US.OUR_SOFTWARE.HEADING_MOBILE' | translate"
      ></div>

      <!-- mobile heading -->
      <div
        class="software-topic__heading software-topic__heading--mobile color-gray"
        [innerHTML]="'WORK_WITH_US.OUR_SOFTWARE.HEADING_MOBILE' | translate"
      ></div>

      <div class="software-topic__heading-detail">{{ 'WORK_WITH_US.OUR_SOFTWARE.DETAIL' | translate }}</div>
    </div>

    <!-- content -->
    <div class="box">
      <ng-container *ngFor="let item of ourSoftwareList">
        <div class="box__item">
          <div class="box__image-cover">
            <picture>
              <source srcset="{{ item.imageWebP }}" type="image/webp" />
              <source srcset="{{  item.image }}" type="image/{{ item.imageType }}" />
              <img
                src="{{ item.image }}"
                class="box__image"
                alt="{{ item.logoImageAlt }}"
                title="{{ item.logoImageAlt }}"
                loading="lazy"
              />
            </picture>
          </div>
          <div class="box__image-text color-gray">
            <picture>
              <source srcset="{{ item.logoImageWebP }}" type="image/webp" />
              <source srcset="{{ item.logoImage }}" type="image/{{ item.imageType }}" />
              <img
                src="{{ item.logoImage }}"
                width="30"
                alt="{{ item.logoImageAlt }}"
                title="{{ item.logoImageAlt }}"
                class="package-head-logo"
              />
            </picture>
            {{ item.softwareName }}
          </div>
          <div class="box__image-detail color-gray" [innerHTML]="item.softwareDetail | translate"> </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
